module.exports = __webpack_public_path__ + "assets/img/img227.b6c7541c.png";